export const generatePrompts = (data) => {
    return fetch('/api/v1/prompt-generations/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const getGeneratedPromptsApi = (id) => {
    return fetch(`/api/v1/generated-prompts/${id}/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};

export const generateTopicsApi = (data) => {
    return fetch('/api/v1/topic-generations/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const createTopicsApi = (data) => {
    return fetch('/api/v1/generated-topics/bulk-create/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const getGeneratedTopicsApi = (id) => {
    return fetch(`/api/v1/topic-generations/${id}/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};

export const getGeneratedAllTopicsApi = (id) => {
    return fetch(`/api/v1/generated-topics/?project_id=${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};
